import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { appContextSelector, setContext } from '../modules/app/appSlice';
import { switchUserBasedOnContext } from '../modules/user/userSlice';
import { setCurrentImpactSlide } from '../modules/impact/impactSlice';

interface UseContextSwitcher {
  switchContext: (label: PortalContext) => void;
}

const useContextSwitcher = (): UseContextSwitcher => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const currentContext = useSelector(appContextSelector);

  const switchContext = (label: PortalContext): void => {
    if (label === currentContext) {
      return;
    }
    dispatch(switchUserBasedOnContext(label));
    dispatch(setContext(label));
    dispatch(setCurrentImpactSlide(0));
    if (['guest-mychooose', 'guest-wechooose'].includes(label)) {
      history.replace({ pathname: '/guest', search: location.search });
      return;
    }
    history.replace('/');
  };

  return {
    switchContext,
  };
};

export default useContextSwitcher;
